import { routerMiddleware } from 'connected-react-router'
import { History } from 'history'
import { applyMiddleware, createStore, Store } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension'
import { ApplicationState, createRootReducer } from './store'
import thunkMiddleware from 'redux-thunk'
import websocket from 'store/middleware/reduxwebsockets'
import { userMessaging } from './store/middleware/userMessaging/middleware'

const websocketMiddleware = websocket({
	prefix: 'REDUX_WEBSOCKET',
	onOpen: (socket: WebSocket) => {
		window.__socket = socket
	},
	reconnectOnClose: true,
	reconnectInterval: 10000
})

export default function configureStore(history: History, initialState?: ApplicationState): Store<ApplicationState> {
	const composeEnhancers = composeWithDevTools({})

	const store = createStore(
		createRootReducer(history),
		initialState,
		composeEnhancers(applyMiddleware(routerMiddleware(history), thunkMiddleware, websocketMiddleware, userMessaging()))
	)

	return store
}
